module.exports = __webpack_public_path__ + "static/media/icon_journal_mission_selection.cae00062.svg";